// extracted by css-extract-rspack-plugin
export default {"TableWrapper":"DV1vI","Table":"PlOv6","EmptyStateCell":"CLTSe"};